export abstract class Setting {
  name: string;
  sortOrder: number;
  caption: string;
  captionStyle: CaptionStyle;
  visible: boolean;
  _enabled: boolean;
  visualRepresentation: VisualRepresentation;
  svgIconName: string;
  beginGroupBehind: boolean;
  groupName: string;
  enabledChanged: (newValue: boolean) => void | Promise<void>;

  get enabled(): boolean {
    return this._enabled;
  }
  set enabled(value: boolean) {
    if (this._enabled !== value) {
      this._enabled = value;
      if (this.enabledChanged) {
        this.enabledChanged(value);
      }
    }
  }

  constructor() {
    this.sortOrder = 0; //not yet fully implemented
    this.captionStyle = CaptionStyle.Regular;
    this.visible = true;
    this.enabled = true;
  }
}

export enum VisualRepresentation {
  Slider,
  CheckBox,
  Button,
}

export enum CaptionStyle {
  Regular,
  Bold,
}

export class BooleanSetting extends Setting {
  private _value: boolean;
  valueChanged: (newValue: boolean) => void | Promise<void>;

  get value(): boolean {
    return this._value;
  }
  set value(value: boolean) {
    if (this._value !== value) {
      this._value = value;
      if (this.valueChanged) {
        this.valueChanged(value);
      }
    }
  }
  constructor(initObj?: any) {
    super();
    this.visualRepresentation = VisualRepresentation.Slider;
    Object.assign(this, initObj);
  }
}

export class ActionSetting extends Setting {
  action;
  constructor(initObj?: any) {
    super();
    this.visualRepresentation = VisualRepresentation.Button;
    Object.assign(this, initObj);
  }
}
